import { render, staticRenderFns } from "./WhatsappFlotante.vue?vue&type=template&id=94cfaccc&scoped=true"
import script from "./WhatsappFlotante.vue?vue&type=script&lang=js"
export * from "./WhatsappFlotante.vue?vue&type=script&lang=js"
import style0 from "./WhatsappFlotante.vue?vue&type=style&index=0&id=94cfaccc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94cfaccc",
  null
  
)

export default component.exports